module.exports = __webpack_public_path__ + "static/media/Mudmie Chuthamsatid.9814e87c.png";